import React from 'react'
import type { ToasterProps } from '../component'
import { Bounce, ToastContainer } from 'react-toastify'
import './ReactToastify.scss'

export const ReactToastify = (_props: ToasterProps) => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      transition={Bounce}
    />
  )
}
